import React from 'react';
import { useLogger } from '@hooks';
import { debugSettingsContext } from '../debugSettings';

interface ComponentInfoProps {
	name: string;
}

export const ComponentInfo: React.FC<ComponentInfoProps> = ({ name, children }) => {
	const { componentInfo } = React.useContext(debugSettingsContext);
	const logger = useLogger();

	logger('ComponentInfo', { componentInfo });

	if (!componentInfo) {
		return <>{children}</>;
	}

	return (
		<div style={{ border: '1px solid grey' }}>
			{name}
			{children}
		</div>
	);
};
